import React from 'react';
import GenericTableSkeleton from '../GenericTableSkeleton/GenericTableSkeleton';

const ReportsTableSkeleton = () => {
  const columnTypes = [
    'cell-short',
    'cell-long',
    'badge',
    'badge',
    'cell-short',
    'cell-lg',
    'badge',
  ];

  return <GenericTableSkeleton columns={7} rows={10} columnTypes={columnTypes} />;
};

export default ReportsTableSkeleton;
